import React from 'react';
import { ComplianceBadge } from '../components/ComplianceBadge';
import { ComplianceStatusEnum } from '../../../shared/types/business-functions-workarounds';

/**
 * Renders compliance badges for workaround timeline compliance
 * @param complianceData - Record containing compliance status data with keys containing 'Compliant'
 * @param workaroundRecord - The record containing isWorkaroundNeeded property
 * @returns React elements for compliance badges
 */
export const renderComplianceBadges = (
  complianceData: Record<string, ComplianceStatusEnum>,
  workaroundRecord: { isWorkaroundNeeded: boolean },
): React.ReactNode[] => {
  return Object.entries(complianceData).map(([key, compliantStatus]) => {
    if (key.includes('Compliant')) {
      const label: string = key.replace('Compliant', '').toUpperCase(); // e.g. slaCompliant -> SLA
      const noWorkaround = !workaroundRecord?.isWorkaroundNeeded;

      return (
        <div key={key} className="inline-block mr-1">
          <ComplianceBadge
            status={compliantStatus}
            label={label}
            noWorkaround={noWorkaround}
          />
        </div>
      );
    }
    return null;
  });
};
